import React from 'react';
import { useTranslation } from 'react-i18next';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import { Theme, Typography, useMediaQuery } from '@mui/material';
import { QInputForm, useQAlert } from '@kubiq-base/core';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../state/ApiContext';
import { useCache } from '../../state/CachingContext';
import HeaderWithDescription from '../Shared/HeaderWithDescription';
import PageError from '../Shared/PageError';
import CenteredQButton from '../Shared/CenteredQButton';
import FlexFormContainer from '../Shared/FlexContainers/FlexFormContainer';

const VerifyRemoveAccount = (): JSX.Element => {
  const namespace = TranslationNamespaces.recovery;
  const { t } = useTranslation(namespace);
  const { deleteRequest } = useApi();
  const { getCache, clearCache } = useCache();
  const session = getCache();
  const { enqueueAlert } = useQAlert();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<{ word: string }>({ mode: 'onBlur', reValidateMode: 'onChange' });

  const sm = !useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const passPhrase = 'IDP.AtiQx.ID';

  const onSubmit = async (): Promise<void> => {
    setIsSubmitting(true);
    deleteRequest('User/DeleteAccount', [
      { name: 'email', value: session.email },
      { name: 'token', value: session.token },
    ])
      .then(() => {
        enqueueAlert(t('deleteComplete'), { type: 'success', autoHideDuration: 5000 });
        clearCache('email');
        clearCache('token');
        navigate('/');
      })
      .catch(() => setIsSubmitting(false));
  };

  return (
    <>
      {session && session.email && session.token ? (
        <>
          <HeaderWithDescription translationNamespace={namespace} headerSuffix='DeleteAccount' />
          <Typography variant={sm ? 'h6' : 'h5'} sx={{ mb: 1 }} align='center'>
            {t('pleaseType')} &quot;<b>{passPhrase}</b>&quot; {t('toConfirm')}
          </Typography>

          <FlexFormContainer onSubmit={handleSubmit(onSubmit)}>
            <QInputForm
              control={control}
              name='word'
              rules={{ required: 'requiredField', validate: (value) => value === passPhrase }}
              isError={
                (errors.word && errors.word.type === 'validate' && t('sameAs')) ||
                (errors.word && t(errors.word.message as string))
              }
              onPaste={(e: ClipboardEvent) => {
                e.preventDefault();
                return false;
              }}
            />

            <CenteredQButton type='submit' color='secondary' fullWidth isLoading={isSubmitting}>
              {t('confirmDelete')}
            </CenteredQButton>
          </FlexFormContainer>
        </>
      ) : (
        <PageError code='500' message='wentWrong' />
      )}
    </>
  );
};

export default VerifyRemoveAccount;
